"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDestinationSuggestions = exports.getSuggestions = void 0;

var _lodash = require("lodash");

var _get = _interopRequireDefault(require("lodash/get"));

var constants = _interopRequireWildcard(require("../constants"));

var _urlLib = require("url-lib");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getFallbackSuggestions = function _getFallbackSuggestions() {
  return Promise.resolve(constants.FALLBACK_SUGGESTIONS);
};

var _parseSuggestionsFromResponse = function _parseSuggestionsFromResponse(response, responseGroups) {
  var suggestions = [];

  if (response.version) {
    // The `response` is grouped into groups like `top_match`, `events`, etc.,
    // each with their own sets of results. `SUGGESTIONS_RESPONSE_GROUPS`
    // contains the order in which we want to process those results, so we
    // gather that list into an lodash object.
    suggestions = (0, _lodash.chain)(responseGroups) // Then we map over that ordering an return the list of results for
    // each group. This will result in an array of arrays; an array of
    // group results lists.
    .map(function (group) {
      return response[group] || [];
    }) // Next flatten that array of array into a single-level array of
    // results. We've now lost the grouping information, but for now,
    // we don't care.
    .flattenDeep() // Just in case we got bad data from the API, filter down to just the
    // results where we actually have both a URL and a title
    .filter(function (_ref) {
      var url = _ref.url,
          name = _ref.name;
      return url && name;
    }) // Now that we have a flatten list, convert the API response data
    // for each result into the format that the search suggestions would
    // like. The results `url` will be the `value`, and the results `name`
    // will be the `content`
    .map(function (_ref2) {
      var url = _ref2.url,
          name = _ref2.name;
      return {
        value: url,
        content: name
      };
    }) // lastly get the actual value out of the lodash object
    .value();
  }

  return suggestions;
};

var _fetchSuggestions = function _fetchSuggestions(query, location) {
  return fetch((0, _urlLib.formatUrl)(constants.SUGGESTIONS_API_URL, {
    q: query,
    loc: location
  }), {
    method: 'GET'
  }).then(function (resp) {
    return resp.json();
  }).then(function (resp) {
    return _parseSuggestionsFromResponse(resp, constants.SUGGESTIONS_RESPONSE_GROUPS);
  });
};

var _parseDestinationSuggestions = function _parseDestinationSuggestions(response) {
  var suggestions = [];

  if (response.event && response.event.length > 0) {
    suggestions = response.event.map(function (_ref3) {
      var url = _ref3.url,
          name = _ref3.name;
      return {
        value: url,
        content: name
      };
    });
  }

  return suggestions;
};

var _fetchDestinationSuggestions = function _fetchDestinationSuggestions(query, userLocation) {
  return fetch((0, _urlLib.formatUrl)(constants.DESTINATION_SUGGESTIONS_API_URL, {
    q: query,
    //eslint-disable-next-line
    completion_types: 'event',
    //eslint-disable-next-line
    place_id: (0, _get.default)(userLocation, ['placeId']),
    latitude: (0, _get.default)(userLocation, ['latitude']),
    longitude: (0, _get.default)(userLocation, ['longitude'])
  }), {
    method: 'GET'
  }).then(function (resp) {
    return resp.json();
  }).then(_parseDestinationSuggestions);
};
/**
 * @typedef SearchSuggestion
 * @property {string} value
 * @property {string} content
 */

/**
 * Gets search suggestions based on specified query
 * @param {string} query Current search query
 * @param {string} location=?'Current Location'
 * @returns Promise<SearchSuggestion[]>
 */


var getSuggestions = function getSuggestions(query) {
  var userLocation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : constants.DEFAULT_LOCATION;
  return (// less than 2 is because SOLR won't match on 1 letter
    !query || query.length < 2 ? _getFallbackSuggestions() : _fetchSuggestions(query, userLocation)
  );
};
/**
 * @typedef UserLocation
 * @property {string} placeId
 * @property {string} latitude
 * @property {string} longitude
 */

/**
 * Gets search suggestions based on specified query
 * @param {string} query Current search query
 * @param {object} UserLocation Place identifier for users current location
 * @returns Promise<SearchSuggestion[]>
 */


exports.getSuggestions = getSuggestions;

var getDestinationSuggestions = function getDestinationSuggestions(query, userLocation) {
  return (// less than 2 is because SOLR won't match on 1 letter
    !query || query.length < 2 ? _getFallbackSuggestions() : _fetchDestinationSuggestions(query, userLocation)
  );
};

exports.getDestinationSuggestions = getDestinationSuggestions;
//# sourceMappingURL=search.js.map